//
// # useDrcResults Hook
//
// Watches for DRC results from the workspace state.
// Results are stored when the run-drc tool completes.
//

import { useEffect, useState } from "react";
import { useWorkspace, useWorkspaceSnapshot } from "../../context";
import type { DrcResult } from "./types";

interface DrcResultsState {
  result: DrcResult | null;
  loading: boolean;
}

export function useDrcResults(): DrcResultsState {
  const workspace = useWorkspace();
  const snapshot = useWorkspaceSnapshot();

  const [state, setState] = useState<DrcResultsState>({
    result: null,
    loading: false,
  });

  useEffect(() => {
    // Check if we have DRC results stored in the workspace
    const drcResult = workspace.getDrcResult();
    if (drcResult) {
      setState({ result: drcResult, loading: false });
    }
  }, [workspace, snapshot.contentVersion]);

  return state;
}
